class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (this.activeElement) removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.section]) return;
      
      const htmlContent = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      if (htmlContent) {
        sectionElement.innerHTML = htmlContent;
      }
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.close.bind(this));
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const targetElement = parsedHTML.querySelector(selector);
    return targetElement ? targetElement.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('click', function (event) {
  const addToCartButton = event.target.closest('form[action*="/cart/add"] button[type="submit"], .product-form__submit, .quick-add__submit');
  if (!addToCartButton) return;

  // تحديث محتوى السلة في الخلفية من غير فتح الدراور بالغصب
  setTimeout(() => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartDrawer = document.querySelector('cart-drawer');
        const sourceDrawer = html.querySelector('cart-drawer');
        
        if (cartDrawer && sourceDrawer) {
          cartDrawer.innerHTML = sourceDrawer.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, 800);
});
document.addEventListener('DOMContentLoaded', () => {
  const updateContinueLink = () => {
    const continueLinks = document.querySelectorAll('cart-drawer .drawer__inner-empty a.button, .cart__empty--content a');
    continueLinks.forEach(link => {
      link.setAttribute('href', '/');
    });
  };

  // تحديث الرابط فوراً ومع أي تغيير بيحصل في السلة
  updateContinueLink();
  
  const observer = new MutationObserver(updateContinueLink);
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
});
// تعديلات سلة المشتريات (حجم الصورة، إزالة زر الـ Checkout المكرر، وتعديل نص الضرائب)
function applyCartDrawerFixes() {
  // 1. ضبط حجم الصورة لتكون contain ومربعة
  const cartImages = document.querySelectorAll('cart-drawer img, .cart-drawer img, .cart-item__image');
  cartImages.forEach(img => {
    img.style.width = '75px';
    img.style.height = '75px';
    img.style.objectFit = 'contain';
    img.style.maxWidth = '75px';
    img.style.maxHeight = '75px';
    img.style.backgroundColor = '#f9f9f9';
    img.style.borderRadius = '4px';
  });

  // 2. إزالة زر الـ Checkout المتكرر تحت خالص
  const checkoutButtons = document.querySelectorAll('cart-drawer .cart__footer button[name="checkout"], cart-drawer .drawer__footer button[type="submit"]');
  if (checkoutButtons.length > 1) {
    for (let i = 1; i < checkoutButtons.length; i++) {
      checkoutButtons[i].remove();
    }
  }

  // 3. تعديل جملة الضرائب والشحن
  const taxNotes = document.querySelectorAll('cart-drawer .tax-note, .cart__tax, .tax-note, .cart-drawer__footer small, cart-drawer p, small');
  taxNotes.forEach(el => {
    if (el.textContent.includes('calculated at checkout') && !el.textContent.includes('Estimated Fees')) {
      el.textContent = 'Estimated Fees calculated at checkout.';
    }
  });
}

// تنفيذ التعديلات فور تحميل السلة أو حدوث أي تحديث فيها
document.addEventListener('DOMContentLoaded', applyCartDrawerFixes);
// ربطها بأي ضغطة تحديث جوه درج السلة لتطبيق التعديلات فوري
document.addEventListener('click', (e) => {
  if (e.target.closest('cart-drawer, .cart-drawer, [id*="cart"]')) {
    setTimeout(applyCartDrawerFixes, 200);
  }
});